/**
 * Class for the canDeactivate functionality
 */
var CanDeactivateGuard = /** @class */ (function () {
    function CanDeactivateGuard() {
    }
    /**
     * Used to test if the component can be deactived (overridable)
     * @param component The component with can deactivate functionality
     * @returns Returns if the component is deactivatable
     */
    CanDeactivateGuard.prototype.canDeactivate = function (component) {
        return component.canDeactivate ? component.canDeactivate() : true;
    };
    return CanDeactivateGuard;
}());
export { CanDeactivateGuard };
